import * as React from 'react';

// Delays transition to false, preventing flicker when loading states overlap
export default (isLoading: boolean, delay: number = 300): boolean => {
    const [debouncedLoading, setDebouncedLoading] = React.useState(isLoading);

    React.useEffect(() => {
        if (isLoading) {
            setDebouncedLoading(true);
            return;
        }

        const timer = setTimeout(() => setDebouncedLoading(false), delay);
        return () => clearTimeout(timer);
    }, [isLoading, delay]);

    return debouncedLoading;
};
